import React, { useEffect } from "react";
import Plot from "react-plotly.js";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Projectcolors from "../Utils/Colors";
import { formLabelClasses } from "@mui/material";
import { Alert,Typography } from "@mui/material";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";

function NoiseRemoval(props) {
  const [rawdata, setRawData] = React.useState([]);

  const [lineplotdata, setLineplotdata] = React.useState([]);

  const [lineploty1, setLineploty1] = React.useState([]);
  const [smoothdata, setSmoothData] = React.useState([]);
  const [lineploty2, setLineploty2] = React.useState([]);
  const [rownumber, setRownumber] = React.useState(0);
  const [remove_noise_data, setRemovenoise] = React.useState([]);
  const [ylabel, setYLabel] = React.useState("Y axis");
  const [remove, setremove] = React.useState(false);
  const [saved, setsaved] = React.useState(false);
  const colorslist = [
    "#3366cc",
    "#dc3912",
    "#ff9900",
    "#109618",
    "#990099",
    "#0099c6",
    "#dd4477",
    "#aaaa11",
    "#743411",
    "#e67300",
    "#22aa99",
    "#994499",
    "#22aa99",
    "#66aa00",
    "#6633cc",
    "#3366cc",
    "#8b0707",
    "#651067",
    "#329262",
    "#5574a6",
    "#3b3eac",
    "#b77322",
    "#16d620",
    "#b91383",
    "#f4359e",
    "#9c5935",
    "#a9c413",
    "#2a778d",
    "#668d1c",
    "#bea413",
    "#0c5922",
    "#b82e2e",
  ];
  const [colors, setColors] = React.useState(colorslist[0]);
  const [getLoader, setGetLoader] = React.useState(false);

  useEffect(() => {
    noiseData();
  }, []);

  const noiseData = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/noisedata?projectID=${ProjectID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((raw) => {
        setRawData(raw.raw_data);
        setLineplotdata(raw.lineplotdata);
        setLineploty1(raw.lineplotdata[0]);
        setSmoothData(raw.smoothdata);
        setLineploty2(raw.smoothdata[0]);
        setRemovenoise(raw.lineplotdata);
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };

  function handlerowclick(number) {
    setLineploty1(lineplotdata[number]);
    setLineploty2(smoothdata[number]);
    setRownumber(number);
    setYLabel(rawdata[number][1]);
    setColors(colorslist[number]);
    setremove(false);
    setsaved(false);
  }

  function removenoise() {
    //remove_noise_data[0] = lineploty2;
    remove_noise_data.splice(rownumber, 1, lineploty2);
    setremove(true);
    setsaved(false);
  }

  const savefiltereddata = () => {
    const ProjectID = sessionStorage.getItem("projectID");

    const body = {
      filtereddata: remove_noise_data,
      ProjectID,
    };

    try {
      fetch(`${baseURL}/savefilterdata`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setsaved(true);
          setremove(false);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
  <Box sx={{ p: 2 }}>

    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "22px",
        bgcolor: "#fff",
        boxShadow:
          "0px 8px 30px rgba(0,0,0,.06)"
      }}
    >

    
      {/* TABLE */}

      <TableContainer
        sx={{
          height: 250,
          borderRadius: "14px",
          overflow: "auto",
          border:
            "1px solid rgba(0,120,201,.15)"
        }}
      >

        <Table stickyHeader>

          <TableHead>

            <TableRow>

              {[
                "Tag Name",
                "Description",
                "Unit Of Measure"
              ].map((item)=>(

                <TableCell
                  key={item}
                  sx={{
                    backgroundColor:"#0078c9",
                    color:"#fff",
                    fontSize:"12px",
                    fontWeight:600
                  }}
                >
                  {item}
                </TableCell>

              ))}

            </TableRow>

          </TableHead>

          <TableBody>

            {rawdata?.map((item,i)=>(

              <TableRow
                key={i}
                hover
                onClick={() => handlerowclick(i)}

                sx={{
                  cursor:"pointer",

                  "&:hover":{
                    background:"#f5f9ff"
                  }
                }}
              >

                {item.map((data,idx)=>(

                  <TableCell
                    key={idx}
                    sx={{
                      fontSize:"12px",
                      py:1.5
                    }}
                  >
                    {data}
                  </TableCell>

                ))}

              </TableRow>

            ))}

          </TableBody>

        </Table>

      </TableContainer>


      {/* CHART CARD */}

      <Paper
        elevation={0}
        sx={{
          mt:2,
          p:2,
          borderRadius:"18px",
          bgcolor:"#fff",
          boxShadow:
            "0px 6px 20px rgba(0,0,0,.05)"
        }}
      >

        <Plot
          data={[
            {
              x:Array.from(
                Array(lineploty1.length).keys()
              ),
              y:lineploty1,
              type:"line",
              mode:"lines+markers",
              marker:{
                color:"#9e0b22"
              },
              name:"Raw Data"
            },

            {
              x:Array.from(
                Array(lineploty2.length).keys()
              ),

              y:lineploty2,

              type:"line",

              mode:"lines+markers",

              marker:{
                color:"#0078c9"
              },

              name:"Smoothed Data"
            }
          ]}

          layout={{
            autosize:true,
            width:900,
            height:220,

            margin:{
              l:50,
              r:30,
              t:20,
              b:50
            },

            paper_bgcolor:"white",
            plot_bgcolor:"white",

            xaxis:{
              title:{
                text:"Count",
                font:{
                  size:12
                }
              }
            },

            yaxis:{
              title:{
                text:
                ylabel.length>20
                ? ylabel.substring(0,20)+"..."
                : ylabel,

                font:{
                  size:12
                }
              }
            }
          }}

          config={{
            responsive:true,
            displaylogo:false
          }}
        />

      </Paper>


      {/* FOOTER */}

      <Box
        sx={{
          mt:2,
          display:"flex",
          justifyContent:
          "space-between",
          alignItems:"center",
          flexWrap:"wrap",
          gap:2
        }}
      >

        <Box
        sx={{
          display:"flex",
          gap:1,
          flexWrap:"wrap"
        }}
        >

          {remove && (

            <Alert
              severity="success"

              sx={{
                borderRadius:"12px",
                fontSize:"12px"
              }}
            >
              Noise Removed
            </Alert>

          )}

          {saved && (

            <Alert
              severity="success"

              sx={{
                borderRadius:"12px",
                fontSize:"12px"
              }}
            >
              Filtered Data Saved
            </Alert>

          )}

        </Box>



        <Box
        sx={{
          display:"flex",
          gap:1
        }}
        >

          <Button
            onClick={removenoise}
            disabled={!props.editAccess}
            variant="contained"

            sx={{
              background:"#9e0b22",
              borderRadius:"12px",
              px:3,
              height:42,
              fontSize:"12px",

              "&:hover":{
                background:"#86081d"
              }
            }}
          >
            Remove Noise
          </Button>


          <Button
            onClick={savefiltereddata}
            disabled={!props.editAccess}
            variant="contained"

            sx={{
              background:"#0078c9",

              borderRadius:"12px",

              px:3,

              height:42,

              fontSize:"12px",

              boxShadow:
              "0px 8px 18px rgba(0,120,201,.25)",

              "&:hover":{
                background:"#0065aa"
              }
            }}
          >
            Apply
          </Button>

        </Box>

      </Box>

    </Paper>

    {getLoader && <GlobalLoader />}

  </Box>
);
}

export default NoiseRemoval;
